import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ReferralState {
  isCtaHidden: boolean;
}

const initialState: ReferralState = {
  isCtaHidden: false,
};

const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    setCtaHidden: (state, action: PayloadAction<boolean>) => {
      state.isCtaHidden = action.payload;
    },
    hideCta: (state) => {
      state.isCtaHidden = true;
    },
    showCta: (state) => {
      state.isCtaHidden = false;
    },
  },
});

export const { setCtaHidden, hideCta, showCta } = referralSlice.actions;
export default referralSlice.reducer;
